import { Dimensions } from 'react-native';

export const vw = Dimensions.get('window').width;
export const vh = Dimensions.get('window').height;
export const vmin = Math.min(vw, vh);
export const vmax = Math.max(vw, vh);
